import React, { Component } from "react";
import { Form, Row, Col } from "antd";
import { ErrorMessageExceptional,InfoMessage, UserIdForm, NewSectionHeading, FormItemContainer, InfoMessageContent, ToolTipSpan, DrawerSectionContent, Snag, HitASnag, FormItem } from "./styles";
import { ContactUs, CustomisedInput,HorizontalDivider, UpdateButton } from "../../styles";
import { UpdateNewmfaEmail, clearmfaEmailErrMessage } from "../../actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UpdateEmailIDSuccess from "./UpdateEmailIDSuccess"
import { getAccountData,getPrimaryAccount } from "../../../../utils/sessionUtil"
import { initiateTracking } from '../../../../utils/commonUtil';
import { ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import PropTypes from 'prop-types';
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";
import { getAuth0UserInfo } from '../../../../Auth0/SessionProvider';
import regexMap from "../../../../utils/regexMap";
import isEmail from 'validator/lib/isEmail';


const err1 = "Please enter an email.";
const err2 = "Please enter a valid email address.";
const err3 = "This email doesn't match our records. Please try again.";
const err4 = "Emails must match.";
const err5 = "New mail cannot match current email.";
const blacklisted_chars = '`,~,!,#,$,%,^,&,*,+,=,{,},|,\,<,/,?,\'';

class UpdateEmailIDComponent extends Component {
  state = {
    formData: {},
    old: "",
    new: "",
    confirm: "",
    confirmDirty: false,
    checked1: false,
    checked2: false,
    checked3: false,
    checked5: false,
    checked6: false,
    hasSpecial1: false,
    hasSpecial2: false,
    strengthValue: 0,
    color: "null",
    errMsgOld: '',
    errMsgNew: '',
    errMsgConfirm: '',
    isChanged: false,
    update:false,
    data:false,
    updateErrMsg:"",
    infoMsg: " "
  };

  pageTitle = "Update Email";

  onEnterData=(e,type)=>{
    this.setState({ infoMsg: " " })
    this.setState({ updateErrMsg : ''})
    if (type === "old") {
      this.setState({
        old: e.target.value, errMsgOld: ''
      },
      () => {
        this.checkEmailFormat(type);
      });
    }else if (type === "new") {
        this.setState(
          {
            new: e.target.value, errMsgNew: ''
          },
          () => {
            this.checkEmailFormat(type);
          }
        );
      }else if (type == 'confirm') {
        this.setState(
          {
            confirm: e.target.value, errMsgConfirm: ''
          },
          () => {
            this.checkEmailFormat(type);
          }
        );
      } 
  }

  checkEmailFormat = (type) => {
    if (type === "old") {
      if (regexMap.auth0emailRegEx.test(this.state.old)) {
        this.setState(
          {
            checked3: true
          },
        );
      } else if (this.state.old === "") {
        this.setState({
          checked3: false
        });
      } else {
        this.setState({
          checked3: false
        });
      }
    }else if (type === "new") {
    if (isEmail(this.state.new,{blacklisted_chars:blacklisted_chars})) {
      this.setState(
        {
          checked1: true
        },
      );
    } else if (this.state.new === "") {
      this.setState({
        checked1: false
      });
    } else {
      this.setState({
        checked1: false
      });
    }
  }else if (type === 'confirm') {
    if (isEmail(this.state.confirm,{blacklisted_chars:blacklisted_chars})) {
      this.setState(
        {
          checked2: true
        },
      );
    } else if (this.state.confirm === "") {
      this.setState({
        checked2: false
      });
    } else {
      this.setState({
        checked2: false
      });
    }
  }
  };
  
  renderPrimaryButton = () => {    
    const required = this.state.old && this.state.new && this.state.confirm;
    const errorVal = this.state.checked1 && this.state.checked2 && this.state.checked3;
    const bval = required && errorVal;
    return bval;
  }

  handleConfirmBlur = (e, type) => {
    this.setState({ infoMsg: " " });  
    if (type == 'old') {        
      if (this.state.old == "") {
        this.setState({ errMsgOld: err1 });
      } else if (!this.state.checked3){
        this.setState({errMsgOld:err2})
    }else if (this.state.old.toString().toLowerCase().trim() !== this.props.emailId.toString().toLowerCase().trim()){
      this.setState({errMsgOld:err3})
    }else {
          this.setState({ errMsgOld: '' });
        }
    } else if (type == 'new') {
        if (this.state.new == "") {
          this.setState({ errMsgNew: err1 });
        } else if (!this.state.checked1){
            this.setState({errMsgNew:err2})
        }else {
            this.setState({ errMsgNew: '' });
          }
      }else if (type == 'confirm') {
        if (this.state.confirm == "") {
          this.setState({ errMsgConfirm: err1 });
        } else if (!this.state.checked2){
            this.setState({errMsgConfirm:err2})
        }else {
            this.setState({ errMsgConfirm: '' });
          }
      }
      if(this.state.checked1 && this.state.checked2 && this.state.checked3){
        if (this.state.old && this.state.new && this.state.confirm) {
        if (this.state.new.toString().toLowerCase().trim() !== this.state.confirm.toString().toLowerCase().trim()) {
          if (type == 'new' || type == 'confirm') {
            this.setState({ errMsgNew: err4,errMsgConfirm: err4 })
          }
        } else if(this.state.old.toString().toLowerCase().trim() === this.state.new.toString().toLowerCase().trim()) {
          if (type == 'new' || type == 'confirm') {
            this.setState({ errMsgNew: err5,errMsgConfirm: err5})
          }
        }else  {
          this.setState({ errMsgNew: '', errMsgConfirm: '' });
        }
      }
    } 
  };

  clearResMsg() {
    if (this.props.mfaEmailExistsBefore) {
      this.props.clearmfaEmailErrMessage();
  }
  }
    validateAllFields() {
        var err = 0;
        if (this.state.old == "") {
          this.setState({ errMsgOld: err1 })
          err++;
        } else if (!this.state.checked3){
          this.setState({ errMsgOld:err2});
          err++;
        } else if (this.state.old.toString().toLowerCase().trim() !== this.props.emailId.toString().toLowerCase().trim()){
          this.setState({errMsgOld:err3});
          err++;
        } else {
          this.setState({ errMsgOld: '' })
        }

        if (this.state.new == "") {
          this.setState({ errMsgNew: err1 })
          err++;
        } else if (!this.state.checked1){
          this.setState({errMsgNew:err2});
          err++;
        } else {
          this.setState({ errMsgNew: '' })
        }

        if (this.state.confirm == "") {
          this.setState({ errMsgConfirm: err1 });
        } else if (!this.state.checked2){
            this.setState({errMsgConfirm:err2})
        }else {
            this.setState({ errMsgConfirm: '' });
          }

          if (this.state.old && this.state.new && this.state.confirm) {
          if (this.state.new.toString().toLowerCase().trim() !== this.state.confirm.toString().toLowerCase().trim()) {
            this.setState({ errMsgNew: err4,errMsgConfirm: err4})
            err++;
          } else if (this.state.old.toString().toLowerCase().trim() === this.state.new.toString().toLowerCase().trim()) {
            this.setState({ errMsgNew: err5, errMsgConfirm: err5 })
              err++
          }else {
            this.setState({errMsgNew: '', errMsgConfirm: '' })
        }
      }
        if (err != 0) {
          const drawerClose = document.getElementsByClassName('ant-drawer-close');
          drawerClose[0].classList.remove('freezeclosepointer');
          this.props.changeMaskClose(false);
          return false;
        }
        return true;
   }
   updatemfaEmail = async (dataInfo='') => {
    this.setState({
      isChanged: true
    }); 
    const auth0userinfo = await getAuth0UserInfo();
    const params = {
    "partyId": getAccountData()?.partyId,
    "auth0UserId":auth0userinfo.sub,
    "mfaEmailId":this.props.emailId.trim(),
    "newMFAEmailId": this.state.new.trim()
    }
    this.props.UpdateNewmfaEmail({
      metaData: [
      {
      method: "POST",
      url: `/donor-portal/api/profile/${getPrimaryAccount().userId}/updateMFAEmailId`,
      data: params
        }
      ]
    })
  }

  setPageTitle = (title='') => {
    if(title) {
        this.pageTitle = title;
    }
  }

  getPageTitle = () => {
      return this.pageTitle;
  }

  handleSubmit = e => {
     e.preventDefault();
     this.props.changeMaskClose(true);
     const newclas=document.getElementsByClassName('ant-drawer-close')
    newclas[0].classList.add('freezeclosepointer');
     let validation = this.validateAllFields();
     if(validation) {
         this.updatemfaEmail()
     } 
  }

  componentDidUpdate(prevProps){
    if(this.props.apiResponseCheck !== prevProps.apiResponseCheck && this.props.apiResponseCheck ){
      this.props.changeMaskClose(true)
    }
    if(this.props.updatemfaEmailData) {
      initiateTracking('next', this.getPageTitle(), 'New Email ID', 'Next')
    }
  }
  render() {  
    const { updatemfaEmailData,apiResponseCheck } = this.props;
    if (updatemfaEmailData==true) {
     this.state.isChanged = true;
    } else {
      this.state.isChanged = false;
    }
    if(apiResponseCheck==true){
      const newclas=document.getElementsByClassName('ant-drawer-close')
      newclas[0].classList.remove('freezeclosepointer');      
    }
  
    return (
      <>        
        {this.state.isChanged === false ? (<div>
          <NewSectionHeading>
            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_11_title" defaultMessage="Update Email" setTitle={this.setPageTitle} />
          </NewSectionHeading>
          <DrawerSectionContent className="mb-50">
          </DrawerSectionContent>
          <Row>
            <Col lg={13} md={13}>
              <UserIdForm onSubmit={this.handleSubmit}>
                <FormItem label="Email">
                <CustomisedInput                      
                      data-test="oldmfaemail-input"
                      id="txtOldmfaEmail"
                      placeholder="Enter Email"
                      setFieldsValue={this.state.old}
                      onChange={e => this.onEnterData(e, "old")}
                      onBlur={e => this.handleConfirmBlur(e, "old")}
                      onFocus={this.clearResMsg.bind(this)}
                      autoComplete="off"
                      className="securityQuesAnswer"
                    />
                    <ErrorMessageExceptional>{this.state.errMsgOld}</ErrorMessageExceptional>
                </FormItem>
                <FormItem label="New Email">
                <CustomisedInput                      
                      data-test="newmfaemail-input"
                      id="txtNewmfaEmail"
                      placeholder="Enter new Email"
                      setFieldsValue={this.state.new}
                      onChange={e => this.onEnterData(e, "new")}
                      onBlur={e => this.handleConfirmBlur(e, "new")}
                      onFocus={this.clearResMsg.bind(this)}
                      autoComplete="off"
                      maxLength="132"
                      className="securityQuesAnswer"
                    />
                    <ErrorMessageExceptional>{this.state.errMsgNew}</ErrorMessageExceptional>
                </FormItem>
                <FormItemContainer label="Confirm New Email">
                  
                    <CustomisedInput                      
                      data-test="confirmmfaemail-input"
                      id="txtConfirmmfaEmail"
                      placeholder="Confirm new Email"
                      setFieldsValue={this.state.new}
                      onChange={e => this.onEnterData(e, "confirm")}
                      onBlur={e => this.handleConfirmBlur(e, "confirm")}
                      onFocus={this.clearResMsg.bind(this)}
                      autoComplete="off"
                      maxLength="132"
                      className="securityQuesAnswer"
                    />
                    <ErrorMessageExceptional>{this.state.errMsgConfirm}</ErrorMessageExceptional>
                    {this.props.mfaEmailExists?(<ErrorMessageExceptional>{this.props.mfaEmailExists}</ErrorMessageExceptional>):(null)}
                    {(this.props.mfaEmailExistsBefore==true)?(<ErrorMessageExceptional>Email already exists. Try again.</ErrorMessageExceptional>):(null)}
                </FormItemContainer>
                <Form.Item>
                  <GeneralButton
                    type="functional"
                    text="SAVE"
                    htmlType="submit"
                    disabled={!this.renderPrimaryButton()}
                    id="btnSubmit"
                    maxWidth="990px"
                    fontSize="18px"
                    styling="mt-10"
                    width="60%"
                    mobWidth="100%"
                  />
                </Form.Item>
              </UserIdForm>
                            
            </Col>
          </Row>
          <HorizontalDivider />
          <Row>
          <Col>
          <HitASnag style={Snag}>                                
                  <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_8_title" defaultMessage="Hit a Snag?" />
              </HitASnag>
              <ContactUs>
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_type_8_description" defaultMessage="<p>Contact us: <br> <span class='updateUserIdSnagContent'>888-383-4483</span> or <br> <span class='updateUserIdSnagContent'>https://www.vanguardcharitable.org/contact-us</span></p>"/>
              </ContactUs>
              </Col>
              </Row>
              
        </div>) : (
          <UpdateEmailIDSuccess mfaEmail={this.props.emailId} newmfaEmail={this.state.new} closeDrawer={this.props.onClose}/>
        )
        }     
      </>
    );
  }
}

UpdateEmailIDComponent.propTypes = {
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  id: PropTypes.number,
  changeMaskClose: PropTypes.func.isRequired
}

const WrappedRegistrationForm = Form.create({ name: "register" })(
  UpdateEmailIDComponent
);

const mapStateToProps = state => ({  
  accountID: state.getIn(["globalState", "accountID"]),  
  updatemfaEmailData: state.getIn(["myAccount", "updatemfaEmailData"]),
  updatemfaEmailFailed: state.getIn(["myAccount", "updatemfaEmailFailed"]),
  mfaEmailExists: state.getIn(["myAccount","mfaEmailExists"]),
  mfaEmailExistsBefore: state.getIn(["myAccount","mfaEmailExistsBefore"]),
  apiResponseCheck: state.getIn(["myAccount","mfaEmailapiFlag"])
});

export const mapDispatchToProps = dispatch => ({  
  UpdateNewmfaEmail: data => dispatch(UpdateNewmfaEmail(data)) ,
  clearmfaEmailErrMessage: () => dispatch(clearmfaEmailErrMessage())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WrappedRegistrationForm)
);
